import React from "react";

const Contact = () => {
  return (
    <div>
      {/* Breadcrumbs Section */}
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
              
                <ul className="bread-list">
                  <li><a href="/">Home</a></li>
                  <li><i className="icofont-simple-right"></i></li>
                  <li className="active">Contact Us</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Us Section */}
      <section className="contact-us section">
        <div className="container">
          <div className="inner">
            <div className="row">
              {/* Right Column: Contact Form */}
              <div className="col-lg-12">
                <div className="contact-us-form">
                  {/* Container around the iframe */}
                  <div className="iframe-container" style={{ position: "relative", height: "814px", width: "100%" }}>
                    <iframe
                      src="https://api.leadconnectorhq.com/widget/form/o5BmFFZsdNaSD2algOjk"
                      style={{
                        width: "100%",
                        height: "814px",  // Adjusted height for the iframe
                        border: "none",
                        borderRadius: "3px",
                        display: "block", // Ensures proper block-level display
                      }}
                      id="inline-o5BmFFZsdNaSD2algOjk"
                      data-layout="{'id':'INLINE'}"
                      data-trigger-type="alwaysShow"
                      data-trigger-value=""
                      data-activation-type="alwaysActivated"
                      data-activation-value=""
                      data-deactivation-type="neverDeactivate"
                      data-deactivation-value=""
                      data-form-name="CONTACT FORM"
                      data-height="814"
                      data-layout-iframe-id="inline-o5BmFFZsdNaSD2algOjk"
                      data-form-id="o5BmFFZsdNaSD2algOjk"
                      title="CONTACT FORM"
                    ></iframe>
                  </div>
                  <script src="https://link.msgsndr.com/js/form_embed.js"></script>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="contact-info">
            <div className="row">
              {/* Single Info: Phone */}
              <div className="col-lg-4 col-12">
                <div className="single-info">
                  <i className="icofont icofont-ui-call"></i>
                  <div className="content">
                    <h3>+1 (415) 650 4414</h3>
                    <p>info@financialprosonline.com</p>
                  </div>
                </div>
              </div>
              {/* Single Info: Address */}
              <div className="col-lg-4 col-12">
                <div className="single-info">
                  <i className="icofont-google-map"></i>
                  <div className="content">
                    <h3>759 Appian Way Suite 2D</h3>
                    <p>Pinole, California 94564</p>
                  </div>
                </div>
              </div>
              {/* Single Info: Office Hours */}
              <div className="col-lg-4 col-12">
                <div className="single-info">
                  <i className="icofont icofont-wall-clock"></i>
                  <div className="content">
                    <h3>Monday – Friday: 07:00 – 10:00</h3>
                    <p>Saturday – Sunday:<br /> 12:00 – 06:00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
